/**
 * Formatting utility functions
 */

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatCurrencyChange = (value: number): string => {
  const formatted = formatCurrency(Math.abs(value));
  if (value > 0) {
    return `+${formatted}`;
  }
  if (value < 0) {
    return `-${formatted}`;
  }
  return formatted;
};

export const formatPercent = (value: number): string => {
  return `${value.toFixed(2)}%`;
};

export const formatPercentWithSign = (value: number): string => {
  if (Number.isNaN(value)) {
    return '--';
  }
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
};

export const formatPointChange = (value: number): string => {
  const sign = value > 0 ? '+' : value < 0 ? '' : '';
  return `${sign}${value.toFixed(1)} pts`;
};

export const formatPercentChange = (value: number): string => {
  const sign = value > 0 ? '+' : value < 0 ? '' : '';
  return `${sign}${value.toFixed(1)}%`;
};

export const formatDisplayDate = (value?: string): string => {
  if (!value) return '';
  // Parse YYYY-MM-DD format without timezone conversion
  const parts = value.split('-');
  if (parts.length === 3) {
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[2], 10);
    const date = new Date(year, month, day);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    });
  }
  // Fallback to standard parsing
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
};

export const getWeekLabel = (startDate: string): string => {
  // Parse YYYY-MM-DD format without timezone conversion
  const parts = startDate.split('-');
  if (parts.length !== 3) return 'Week ?';
  
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
  const day = parseInt(parts[2], 10);
  const date = new Date(year, month, day);
  
  if (Number.isNaN(date.getTime())) return 'Week ?';
  
  // Calculate ISO week number
  const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = tempDate.getUTCDay() || 7;
  tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
  const weekNum = Math.ceil(((tempDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  
  return `Week ${weekNum}`;
};

export const getDisplayLocationName = (locationName: string): string => {
  if (locationName === 'Cool Springs Blvd - Franklin') {
    return 'Cool Springs';
  }
  return locationName;
};

